<template>
    <div id="referalInviteDiv">
        <HeaderVue isHeader="true"/>
        <div class="loading">
            <div class="loading-img">
                <img src="static/images/walk.gif" alt="">
            </div>
        </div>
        <header class="reg-header passon-header">
        </header>
        <div class="wrapper ">
            <div class="pass-on">
                <div class="inner-page1 reg-content">
                    <div class="container">
                        <div class="row">
                            <div class="col-sm-7">
                                <h1 class="red-color">It's time to pass on the goodness</h1>
                                <p>Thank you for being our esteemed customer. You know it’s convenient to get a home blood test
                                    done through Labotist. Now your friends and family can benefit too. We have made it easy
                                    for you to refer a friend to avail our home blood test services.</p>
                                <p>
                                    You get a credit of INR.100 in your Labotist account when your friend books a blood test
                                    with us. Of course, we won't leave your friend behind! They get an instant credit of
                                    INR.150 as soon as they register with us!
                                </p>
                                <h3>Steps to refer:</h3>
                                <ul>
                                    <li class="steps">
                                        Login using your Labotist login credentials
                                    </li>
                                    <li class="steps">
                                        You will see the message with referral link
                                    </li>
                                    <li class="steps">
                                        Share the message and link via your preferred mode - facebook, whatsapp, Instagram,
                                        email, etc
                                    </li>
                                </ul>
                            </div>
                            <div class="col-sm-5">
                                <div class="ref-form align-center">
                                <h1>Refer Now</h1>
                                <div class="form-group">
                                    <input type="text" class="form-control" id="referralCode" name="referralCode" v-model="referralCode" aria-describedby="emailHelp"
                                        placeholder="Referral Code" disabled>
                                </div>
                                <div class="form-group">
                                    <textarea name="" class="form-control" cols="30" rows="10" v-model="description"></textarea>
                                </div>
                                <div class="form-group">
                                    <input type="text" class="form-control" id="referralUrl" name="referralUrl" ref="copyReferralText" v-on:focus="copyReferralCodeUrl()" v-on:click="copyReferralCodeUrl()" v-model="referralUrl" aria-describedby="emailHelp" data-toggle="tooltip" data-placement="top" title="Copied" placeholder="Link">
                                </div>
                                
                                    <!--<a href=""><i class="fa fa-facebook-square"></i></a>
                                    <a href=""><i class="fa fa-whatsapp-square"></i></a>
                                    <a href=""><i class="fa fa-linkedin-square"></i></a>
                                    <a href=""><i class="fa fa-instagram"></i></a>-->
                                    <!--<social-sharing 
                                                    v-bind:title="title"
                                                    v-bind:description="description"
                                                    v-bind:quote="description"
                                                    v-bind:hashtags="hashtags"
                                                    v-bind:twitter-user="twitterUser"
                                                    v-bind:url="referralUrl"
                                                    inline-template v-if="!$WebView || !$WebViewBridge">
                                        <div class="share-btn text-right mt-3">
                                            Share Via :
                                            <network network="email">
                                                <i class="fa fa-envelope"></i>
                                            </network>
                                        </div>
                                    </social-sharing>-->
                                    <social-sharing 
                                                    v-bind:title="title"
                                                    v-bind:description="description"
                                                    v-bind:quote="description"
                                                    v-bind:hashtags="hashtags"
                                                    v-bind:twitter-user="twitterUser"
                                                    v-bind:url="referralUrl"
                                                    inline-template v-if="!$WebView || !$WebViewBridge">
                                        <div class="share-btn text-right mt-3">
                                            Share Via :
                                            <network network="email">
                                                <i class="fa fa-envelope"></i>
                                            </network>
                                            <network network="facebook">
                                                <i class="fa fa-facebook-square"></i>
                                            </network>
                                            <network network="whatsapp">
                                                <i class="fa fa-whatsapp"></i>
                                            </network>
                                        </div>
                                    </social-sharing>
                                    <div class="share-btn text-right mt-3" v-else>
                                        Share Via :
                                        <span v-on:click="shareLinkThroughWebbridge(1)">
                                            <i class="fa fa-envelope"></i>
                                        </span>
                                        <span v-on:click="shareLinkThroughWebbridge(2)">
                                            <i class="fa fa-facebook-square"></i>
                                        </span>
                                        <span v-on:click="shareLinkThroughWebbridge(3)">
                                            <i class="fa fa-whatsapp"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="copy-right text-center">
                <p>2017 labotist . All rights received.</p>
            </div> -->
        </div>
    </div>
</template>

<script>
import HeaderVue from '@/components/mobile/Header'
// import FooterVue from '@/components/mobile/Footer'
import Sidemenu from '@/components/mobile/Public/Sidemenu'

export default {
  name: 'ReferalLogin',
  components: {
    HeaderVue,
    Sidemenu
    // FooterVue
  },
  data () {
    return {
      referralCode : '',
      referralUrl : 'https://labotist.com/',
      title : 'Labotist - Referral Program',
      quote : 'Hi, \r\n Here is the referral link to register with Labotist.com. They provide home blood test service and on registering you will get a credit of Rs 150 which you can use against your bookings with them, for blood test at home. \r\n   Labotists offers over 1000+ tests in partnership with 50 labs in Bengaluru and Chennai.\n ',
      description : 'Hi, \r\n Here is the referral link to register with Labotist.com. They provide home blood test service and on registering you will get a credit of Rs 150 which you can use against your bookings with them, for blood test at home. \r\n   Labotists offers over 1000+ tests in partnership with 50 labs in Bengaluru and Chennai.\n ',
      hashtags : 'homebloodtest, chennai, bengaluru',
      twitterUser : 'labotist',
      isWebViewIos: this.$IsWebViewIos
    }
  },
  beforeCreate () { },
  created () {
    if (!this.$localStorage.get('loggedIn') || this.$localStorage.get('loggedIn') == null) {
      this.$router.push({ path: '/referral/login' })
    }else {
      this.getProfile()
    }
    this.isWebViewIos = this.$IsWebViewIos
  },
  mounted () {
    this.$hidePageLoading()
    $('input[data-toggle="tooltip"]').tooltip({
        animated: 'fade',
        placement: 'top',
        trigger: 'manual'
    })
  },
  methods : {
    shareLinkThroughWebbridge(type){
        let data = {
            title:this.title,
            description : this.description,
            quote : this.description,
            hashtags : this.hashtags,
            'twitter-user' : this.twitterUser,
            url : this.referralUrl
        }
        switch(type) {
            case 1: 
                if(this.$WebView && this.$WebViewBridge) {
                    data['type'] =  'shareEmail'
                    this.$WebViewBridge.send(JSON.stringify(data));
                } else {
                    console.log('Web bridge not found')
                }
                break;
            case 2:
                if(this.$WebView && this.$WebViewBridge) {
                    data['type'] =  'shareFaceBook'
                    this.$WebViewBridge.send(JSON.stringify(data));
                } else {
                    console.log('Web bridge not found')
                }
                break;
            case 3:
                if(this.$WebView && this.$WebViewBridge) {
                    data['type'] =  'shareWhatsApp'
                    this.$WebViewBridge.send(JSON.stringify(data));
                } else {
                    console.log('Web bridge not found')
                }
                break;
            case 4:
                if(this.$WebView && this.$WebViewBridge) {
                    data['type'] =  'shareInstagram'
                    this.$WebViewBridge.send(JSON.stringify(data));
                } else {
                    console.log('Web bridge not found')
                }
                break;
            default :
                console.log('Sorry something went wrong')
        }
    },
    getProfile: function () {
      try {
        if (this.$localStorage.get('loggedIn') && this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
          var data = {}
          Promise.resolve(this.$GET('patient/getProfile', data)).then(function (res) {
            if (res.response_code === 0) {
              this.referralCode = res.response.Patient.referralCode;
              this.referralUrl = this.$signupUrl + this.$encryptString(res.response.Patient.referralCode);
            }
            this.$hidePageLoading()
          }.bind(this)).catch(function (err) {
            console.error(err)
          })
        }
      } catch (e) {
        console.error('method:getProfile', e)
      }
    },
    copyReferralCodeUrl: function () {
      let referralUrl = document.getElementById('referralUrl')
      setTimeout(function() {
        referralUrl.setSelectionRange(0, referralUrl.value.length);
        document.execCommand("copy");
        $('input[data-toggle="tooltip"]').tooltip("show")
      }, 1);
      
      setTimeout(function(){
          $('input[data-toggle="tooltip"]').tooltip("hide")
      }, 1000)
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/mobile/Public/ReferalInvite.vue